import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import associateServices from "../../../../services";
import Loading from "../../../../components/loading";
import RankIcon from "../../../../components/rank-icon";
import FormButton from "../../../../components/form-button";
import {useSelector} from "react-redux";
import stringHelper from "../../../../helpers/string-helper";

const classes = [
    "accordion-benefits__card--copper",
    "accordion-benefits__card--silver",
    "accordion-benefits__card--bronze",
    "accordion-benefits__card--gold",
    "accordion-benefits__card--diamond",
    "accordion-benefits__card--obsidian",
    "accordion-benefits__card--king",
    "accordion-benefits__card--emerald",
    "accordion-benefits__card--ruby",
    "accordion-benefits__card--sapphire",
    "accordion-benefits__card--amethyst",
    "accordion-benefits__card--topaz",
    "accordion-benefits__card--jade",
    "accordion-benefits__card--onyx",
    "accordion-benefits__card--pearl",
]

const BenefitsModal = (props) => {

    const {activeLanguage} = useSelector(state => state.globalReducer)
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    const {handleClose} = props
    const navigate = useNavigate()
    const [active, setActive] = useState('')
    const handleNavigation = () => {
        handleClose()
        navigate(stringHelper.getLocalizedPath(currentLanguage, '/vip'))
    }

    useEffect(() => {
        associateServices.getVipStates({
            language: activeLanguage?.key
        }).then(res => {
            setItems(res?.data?.map(i => ({
                ...i,
                class: classes[Math.floor(Math.random() * classes.length)]
            })) || [])
            setLoading(false)
        })
    }, [])

    console.log(items)
    return (
        <div className="benefits modal__content">
            <div className="accordion-benefits" id="accordion-benefits">
                {
                    loading ? <Loading/> : items?.map(item => (
                        <div
                            key={item.slug}
                            className={`accordion-benefits__card  ${item.class}`}>
                            <button
                                className="collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse1-${item.slug}`}
                                aria-expanded="false"
                                aria-controls={`#collapse1-${item.slug}`}
                                onClick={e => setActive(item.slug)}
                            >
                                {/*<span>{t(`vip.${item.slug}.title`)}</span>*/}
                                <div className="d-flex align-items-center gap-2">
                                    {
                                        item.icon &&
                                        <RankIcon icon={item.icon}/>
                                    }
                                    <span>{item.name}</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M6 9l6 6l6 -6"/>
                                </svg>
                            </button>
                            <div
                                id={`collapse1-${item.slug}`}
                                className="collapse"
                                data-bs-parent="#accordion-benefits"
                            >
                                <ul>
                                    {
                                        item?.content &&
                                        <div dangerouslySetInnerHTML={{__html: item.content}}/>
                                    }
                                </ul>
                            </div>
                        </div>
                    ))
                }
            </div>


            <FormButton
                label={t('vip.more-about-vip')}
                loading={false}
                disabled={false}
                onClick={handleNavigation}
            />
        </div>

    )

}

export default BenefitsModal
